import React from 'react';

import InspectionHistory from '../../../../tabs/inspectionHistory';

const InspectionHistoryTab = () => {
  return <InspectionHistory />;
};

export default InspectionHistoryTab;
